/** @file Thai catalog part of area E7 (W3-03), partial; replaced whole by that area. */

/** The `general` block of the Settings screen (spread into `settings`); partial, English fills the gaps. S0 composes it into `th`. */
export const settingsExtraTh = { general: 'ทั่วไป' } as const;
